/** Header for the Messages Members view, which publishes its state on
 *  `messages:members-state` instead of drawing a header row of its own:
 *  back (navigation, so leading), the title, and Add people trailing.
 *  Desktop turns the back into the history arrow and shows the conversation
 *  as a breadcrumb before the title (MessagesMembersBreadcrumb). No JSX. */

import { ChevronLeft, Search, UserPlus } from '@/shared/ui/icons';
import type { MobileHeaderAction } from './types';

export interface MessagesMembersHeaderState {
  adding: boolean;
  /** "4 people", or the add-mode hint. */
  subtitle: string;
  /** The conversation, for the desktop breadcrumb. */
  context?: string;
}

/** The desktop history arrow while Members is open: same label and target as
 *  the leading back, so it never falls through to the browser history. */
export const messagesMembersBackAction = (state: MessagesMembersHeaderState) => ({
  id: 'back-messages-members',
  label: state.adding ? 'Back to members' : 'Back to conversation',
  onClick: () => window.dispatchEvent(new CustomEvent('messages:members:back')),
});

export const messagesMembersTitle = (state: MessagesMembersHeaderState) => (state.adding ? 'Add members' : 'Members');

export function buildMessagesMembersHeaderActions(ctx: {
  state: MessagesMembersHeaderState;
  leadingActions: MobileHeaderAction[];
  trailingActions: MobileHeaderAction[];
  pushNotificationsAction: () => void;
  /** Opens the phone's search morph; desktop uses the global field instead. */
  onToggleSearch?: () => void;
}): void {
  const { state, leadingActions, trailingActions, pushNotificationsAction, onToggleSearch } = ctx;
  const back = messagesMembersBackAction(state);
  leadingActions.push({ id: back.id, icon: ChevronLeft, ariaLabel: back.label, onClick: back.onClick });
  // Add members filters people through the header search: on a phone this
  // leading morph (search pills live leading), on desktop the global field.
  if (state.adding && onToggleSearch) {
    leadingActions.push({ id: 'messages-members-search', icon: Search, ariaLabel: 'Search people', onClick: onToggleSearch });
  }
  if (!state.adding) {
    trailingActions.push({
      id: 'messages-members-add',
      icon: UserPlus,
      label: 'Add people',
      ariaLabel: 'Add people',
      onClick: () => window.dispatchEvent(new CustomEvent('messages:members:add')),
      group: 'page',
    });
  }
  pushNotificationsAction();
}
